import type { AdministrationProviderConfig } from '@openx/components-administration/lib/utils/context/AdministrationContext.tsx';
import { useDeleteInventoryList } from './utils/inventoryLists/useDeleteInventoryList.tsx';
import { useInventoryListByIdFetch } from './utils/inventoryLists/useInventoryListByIdFetch.ts';
import { useInventoryListsFetch } from './utils/inventoryLists/useInventoryListsFetch.ts';
import { useSubmitInventoryList } from './utils/inventoryLists/useSubmitInventoryList.ts';
import { useAccountOptionsFetch } from './utils/users/useAccountOptionsFetch.ts';
import { useCreateUser } from './utils/users/useCreateUser.ts';
import { useEditUser } from './utils/users/useEditUser.ts';
import { useGetUsersTableData } from './utils/users/useGetUsersTableData.tsx';
import { useUserDeleteModal } from './utils/users/useUserDeleteModal.tsx';
import { useUserFetch } from './utils/users/useUserFetch.ts';
import { useUserPageHeaderActions } from './utils/users/useUserPageHeaderActions.tsx';
import { useUsersListFetch } from './utils/users/useUsersListFetch.ts';

export const administrationConfig: AdministrationProviderConfig = {
  isOa: true,
  useAccountOptionsFetch,
  useCreateUser,
  useGetUsersTableData,
  useUsersListFetch,
  useDeleteInventoryList,
  useInventoryListByIdFetch,
  useInventoryListsFetch,
  useSubmitInventoryList,
  useUserFetch,
  useUserPageHeaderActions,
  useEditUser,
  useUserDeleteModal,
};
